import { useState } from "react";

// react-router-dom components
import { Link, useLocation, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Images
import bgImage from "assets/images/background.png";
import bg from "assets/images/bg2.png";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useResetPasswordMutation } from "services/auth";
import { useAppDispatch } from "hooks/store";
import ShowToast from "components/MDToast";
import { removeFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import { setCredentials } from "reducers/authSlice";
import { IconButton, InputAdornment } from "@mui/material";
import useTranslation from "hooks/Translation";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const t = useTranslation();
  const { state } = location;
  const dispatch = useAppDispatch();
  const [resetPassword] = useResetPasswordMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      passwordConfirmation: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .label("Password")
        .required(t.error.passReq)
        .min(6, t.error.min6),

      passwordConfirmation: Yup.string()
        .oneOf([Yup.ref("newPassword")], t.error.passNotMatch)
        .required(t.error.confirmPassReq),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);

      let body = {
        new_password: formik.values.newPassword,
        email: state?.email,
      };
      console.log(body, "bodybodybody");

      try {
        const response = await resetPassword(body).unwrap();
        if (response?.status === 200) {
          ShowToast(response?.message || "");
          removeFromStorage(STORAGE_KEYS.token);
          dispatch(
            setCredentials({
              user: null,
              token: null,
            })
          );
        }
      } catch (error) {
        ShowToast(error?.data?.message || "", "error");
      }
      formik.setSubmitting(false);
      navigate("/authentication/sign-in", {
        replace: true,
      });
    },
  });

  return (
    <BasicLayout>
      <Grid
        container
        className="signin-container"
        sx={{ overflow: "hidden", minHeight: "100vh" }}
      >
        {/* Image Section */}
        <Grid
          item
          xs={0}
          md={6}
          sx={{
            display: { xs: "none", md: "block" },
            position: "relative",
            background: "black",
            height: "100vh",
          }}
        >
          <img
            src={bg}
            alt="Sign In"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              marginTop: "-2px",
            }}
          />
        </Grid>

        {/* Form Section */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: { xs: 4, sm: 8 },
          }}
        >
          {/* <Card> */}
          <MDBox sx={{ maxWidth: 500, width: "100%" }} pt={5}>
            <MDBox
              // variant="gradient"
              // bgColor="#2B604C"
              borderRadius="lg"
              // coloredShadow="info"
              mx={2}
              // mt={-3}
              // p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" mt={1}>
                {t.auth.resendPass}
              </MDTypography>
            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
              <form onSubmit={formik.handleSubmit}>
                <MDBox mb={2}>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.newPassword}
                  </MDTypography>
                  <MDInput
                    className="text_field"
                    type="email"
                    placeholder={t.main.newPassword}
                    fullWidth
                    id="newPassword"
                    name="newPassword"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.newPassword}
                    helperText={
                      formik.touched.newPassword && formik.errors.newPassword
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment className="eye_btn" position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.confirmNewPass}
                  </MDTypography>
                  <MDInput
                    className="text_field"
                    type="email"
                    placeholder={t.main.confirmNewPass}
                    fullWidth
                    id="passwordConfirmation"
                    name="passwordConfirmation"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.passwordConfirmation}
                    helperText={
                      formik.touched.passwordConfirmation &&
                      formik.errors.passwordConfirmation
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment className="eye_btn" position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              setConfirmShowPassword(!confirmShowPassword)
                            }
                            onMouseDown={() =>
                              setConfirmShowPassword(!confirmShowPassword)
                            }
                            edge="end"
                          >
                            {confirmShowPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </MDBox>
                <MDBox mt={4} mb={1}>
                  <MDButton
                    variant="gradient"
                    color="success"
                    fullWidth
                    type="submit"
                  >
                    {t.main.submit}
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>
          </MDBox>

          {/* </Card> */}
        </Grid>
      </Grid>
    </BasicLayout>
  );
}
